module.exports = __webpack_public_path__ + "img/crm_case10.1414af1b.png";